module.exports = __webpack_public_path__ + "img/dci-404-bg.78e6c43b.jpg";